import React, { useEffect, useState } from 'react';
import {
  Box,
  Chip,
  CircularProgress,
  Collapse,
  Divider,
  IconButton,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { StudentPastPaperDTO } from '../../services/tutorAssessmentService';
import { api } from '../../services/api';

export default function StudentPastPapersSection({ courseId, nodeId }: { courseId: number; nodeId: number }) {
  const [papers, setPapers] = useState<StudentPastPaperDTO[]>([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState<number | null>(null);

  useEffect(() => {
    api.get<{ data: StudentPastPaperDTO[] }>(
      `/api/student/courses/${courseId}/topics/${nodeId}/past-papers`
    )
      .then(r => setPapers(r.data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [courseId, nodeId]);

  if (loading) return <CircularProgress size={20} />;
  if (papers.length === 0) return null;

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>Past Papers</Typography>
      <Stack spacing={1}>
        {papers.map((p, i) => (
          <Paper key={p.id} variant="outlined">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ p: 1.5, cursor: 'pointer' }}
              onClick={() => setExpanded(expanded === p.id ? null : p.id)}
            >
              <Box>
                <Typography variant="body2" fontWeight={500}>
                  {i + 1}. {p.questionText.length > 80 ? p.questionText.slice(0, 80) + '…' : p.questionText}
                </Typography>
                <Stack direction="row" spacing={0.5} mt={0.5}>
                  {p.yearLabel && <Chip label={p.yearLabel} size="small" />}
                  {p.sourceExam && <Chip label={p.sourceExam} size="small" variant="outlined" />}
                  {p.allocatedMarks && (
                    <Chip label={`${p.allocatedMarks} marks`} size="small" variant="outlined" />
                  )}
                </Stack>
              </Box>
              <IconButton size="small">
                {expanded === p.id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Stack>
            <Collapse in={expanded === p.id}>
              <Divider />
              <Box sx={{ p: 1.5 }}>
                <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>{p.questionText}</Typography>
              </Box>
            </Collapse>
          </Paper>
        ))}
      </Stack>
    </Box>
  );
}
